import React,{ Component } from "react";
import { connect } from "react-redux";
import GroupForm from "../GroupForm/GroupForm";
import { createGroup } from "../../../actions/actionGroup";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Groups",path:"/groups",isActive: false},
    {name: "CreateGroup",path:"/creategroup",isActive: true},
];

class CreateGroup extends Component{
    render(){
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>       
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong> Create Group </strong>
                                </CardHeader>
                                <GroupForm
                                    createGroup={this.props.createGroup}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CreateGroup.propTypes = {
    createGroup: Proptypes.func.isRequired
};


export default connect(state => ({
    groups: state.groups.groups || []
}), 
dispatch => ({
    createGroup: (data) => dispatch(createGroup(data))
}))(CreateGroup);


// WEBPACK FOOTER //
// ./src/views/Groups/CreateGroup/CreateGroup.js